import React from 'react';
import Skeleton from './Skeleton';

/**
 * OrganisationSettingsSkeleton
 * Shimmer placeholder for the Organisation settings page — mirrors its two
 * stacked section cards (Organisation / Care home location), each with a
 * header row and a 2-column grid of fields.
 * Built from the base <Skeleton /> block (pure Tailwind shimmer).
 */

const CARD =
  'bg-white dark:bg-[#262b33] rounded-[20px] border border-[#E3E9F3] dark:border-gray-800 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_10px_-3px_rgba(15,23,42,0.06)]';

const S = Skeleton;

const FieldSkeleton = ({ full = false }) => (
  <div className={full ? 'sm:col-span-2' : ''}>
    <S className="h-3 w-28 rounded-md mb-2" />
    <S className="h-11 w-full rounded-xl" />
  </div>
);

const SectionSkeleton = ({ fields = 5 }) => (
  <div className={CARD}>
    {/* header */}
    <div className="flex items-center justify-between px-6 py-4 border-b border-[#EEF2F8] dark:border-gray-800">
      <div className="flex items-center gap-2.5">
        <S className="h-[18px] w-[18px] rounded-md" />
        <S className="h-4 w-40 rounded-md" />
      </div>
      <S className="h-3 w-28 rounded-md" />
    </div>
    {/* fields */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-6">
      {Array.from({ length: fields }).map((_, i) => (
        <FieldSkeleton key={i} full={i === fields - 1} />
      ))}
    </div>
  </div>
);

const OrganisationSettingsSkeleton = () => (
  <div className="w-full pb-10">
    {/* Header */}
    <div className="mb-5">
      <S className="h-7 w-56 rounded-xl" />
      <S className="h-3.5 w-96 max-w-full rounded-md mt-3" />
    </div>

    <div className="flex flex-col gap-5">
      <SectionSkeleton fields={5} />
      <SectionSkeleton fields={5} />
      <div className="flex justify-end">
        <S className="h-10 w-32 rounded-xl" />
      </div>
    </div>
  </div>
);

export default OrganisationSettingsSkeleton;
